module.exports = __webpack_public_path__ + "img/8.d23947af.jpg";